import api from './api';

export interface AdminProfessorSummary {
  id: number;
  username: string;
  email: string;
  role: string;
  current_stage: string | null;
  profile_id: number | null;
  host_partner_id?: number | null;
  first_name?: string | null;
  last_name?: string | null;
}

export interface CreateProfessorPayload {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  host_partner_id: number;
}

export const professorAdminService = {
  async list(): Promise<{ professors: AdminProfessorSummary[] }> {
    const res = await api.get('/api/admin/professors');
    const payload = res.data;
    if (Array.isArray(payload)) {
      return { professors: payload };
    }
    return payload;
  },
  async get(userId: number): Promise<{ professor: AdminProfessorSummary }> {
    const res = await api.get(`/api/admin/professors/${userId}`);
    return res.data;
  },
  async setStage(userId: number, stage: string): Promise<{ message: string; user_id: number; current_stage: string }> {
    const res = await api.post(`/api/admin/professors/${userId}/stage`, { stage });
    return res.data;
  },
  async create(payload: CreateProfessorPayload): Promise<AdminProfessorSummary> {
    const res = await api.post('/api/admin/professors', payload);
    return res.data;
  }
};
